export const LOCAL_STORAGE_KEY = {
    AUTH_DATA: "Auth.Data",
    AUTH_USER: "Auth.User",
    AUTH_USER_DEVICE: "Auth.UserDevice",
    AUTH_USER_PERMISSIONS: "Auth.UserPermissions",
    AUTH_LAST_LOGGED_IN_USER_ROLE: "Auth.LastLoggedInUserRole",
    AUTOUPDATER_LAST_CHECK_DATE: "Autoupdater.LastCheckDate",
    USERS_LIST_CURSOR_PAGINATION_STATE: "Users.List.CursorPaginationState",
    USERS_LIST_FILTERS_STATUS: "Users.List.Filters.Status",
    USERS_LIST_FILTERS_SEARCH: "Users.List.Filters.Search",
    USERS_LIST_FILTERS_ROLE: "Users.List.Filters.Role",
    USERS_LIST_FILTERS_INCLUDE_DELETED: "Users.List.Filters.IncludeDeleted",
    INVOICING_PLATFORM_CONNECTORS_LIST_FILTERS_PROVIDER:
        "InvoicingPlatformConnectors.List.Filters.Provider",
    INVOICING_PLATFORM_CONNECTORS_LIST_CURSOR_PAGINATION_STATE:
        "InvoicingPlatformConnectors.List.CursorPaginationState",
    API_CLIENTS_LIST_FILTERS_INVOICING_PLATFORM_CONNECTOR:
        "ApiClients.List.Filters.InvoicingPlatformConnector",
    API_CLIENTS_LIST_CURSOR_PAGINATION_STATE: "ApiClients.List.CursorPaginationState",
    INVOICE_INTENTS_LIST_CURSOR_PAGINATION_STATE: "InvoiceIntents.List.CursorPaginationState",
    INVOICE_INTENTS_LIST_FILTERS_INVOICE_TYPE: "InvoiceIntents.List.Filters.InvoiceType",
    INVOICE_INTENTS_LIST_FILTERS_STATUS: "InvoiceIntents.List.Filters.Status",
    INVOICE_INTENTS_LIST_FILTERS_OWNER_ID: "InvoiceIntents.List.Filters.OwnerId",
    INVOICE_INTENTS_LIST_FILTERS_GOV_STATUS: "InvoiceIntents.List.Filters.GovStatus",
    INVOICE_INTENTS_LIST_FILTERS_SEARCH_TYPE: "InvoiceIntents.List.Filters.SearchType",
    INVOICE_INTENTS_LIST_FILTERS_SEARCH_VALUE: "InvoiceIntents.List.Filters.SearchValue",
    INVOICE_INTENTS_LIST_FILTERS_SORT_BY: "InvoiceIntents.List.Filters.SortBy",
    INVOICE_INTENTS_LIST_FILTERS_SORT_DIRECTION: "InvoiceIntents.List.Filters.SortDirection",
    INVOICE_INTENTS_LIST_FILTERS_SELL_DATE_FROM: "InvoiceIntents.List.Filters.SellDateFrom",
    INVOICE_INTENTS_LIST_FILTERS_SELL_DATE_TO: "InvoiceIntents.List.Filters.SellDateTo"
} as const;
